module.exports = __webpack_public_path__ + "static/media/Marco_A.ae563df1.jpg";